import React, { FC } from 'react';
import { PublicJobCreateAlertResponseData } from './types';
import { FlexGrid, FlexGridColumn } from '../../../../components/FlexGrid';
import { EmailSend } from '../../../../components/Icons/EmailSend';
import { gray } from '../../../../components/Color';
import { Typography } from '../../../../components/Typography';

export const PublicJobSubscriptionConfirmation: FC<React.PropsWithChildren<PublicJobCreateAlertResponseData>> = ({
	message1,
	message2,
	message3,
	message4,
}) => {
	return (
		<div>
			<FlexGrid
				gap='small'
				center
				hrCenter
			>
				<EmailSend
					width='30px'
					height='30px'
					fill={gray[5]}
				/>
				<FlexGridColumn>
					<Typography display='block'>{message1}</Typography>
					<Typography display='block'>{message2}</Typography>
				</FlexGridColumn>
			</FlexGrid>
			<hr />
			<Typography
				color={gray[5]}
				fontSize='12px'
				display='block'
				align='center'
			>
				{message3}
			</Typography>
			<Typography
				color={gray[5]}
				fontSize='12px'
				align='center'
			>
				{message4}
			</Typography>
		</div>
	);
};
